export const SelectorEntity = {
	user: 'user',
	department: 'department',
};
